import { z } from 'zod';

export const createInvitadoSchema = z.object({
  nombre: z.string().min(1, 'El nombre es obligatorio').max(120, 'Máximo 120 caracteres'),
  email: z
    .string()
    .email('Email inválido')
    .optional()
    .or(z.literal('')),
  telefono: z
    .string()
    .max(40, 'Máximo 40 caracteres')
    .optional()
    .or(z.literal('')),
  acompanantes_max: z.coerce
    .number({ invalid_type_error: 'Debe ser un número' })
    .int('Debe ser un número entero')
    .min(1, 'Mínimo 1 cupo')
    .max(20, 'Máximo 20 cupos'),
});

export const updateInvitadoSchema = createInvitadoSchema.partial().extend({
  acompanantes_confirmados: z.coerce.number().int().min(0).optional(),
  confirmado: z.coerce.number().int().refine((v) => v === 0 || v === 1 || v === -1, {
    message: 'Estado inválido',
  }).optional(),
});
